import { get } from 'lodash';

import {
  createRestaurantDashboardApi,
  fetchRestaurantDetailsByScanCodeAPI,
  getRestaurantIntegrationsApi,
  updatePOSSyncStatusAPI,
  fetchGuestSegmentsDataApi,
  createSuggestCampaignApi,
  fetchSuggestedCampaignsApi,
  updateSuggestCampaignApi,
  fetchAllBrandsApi,
  fetchSuggestedCampaignBrandsApi,
  suggestCampaignToBrandsApi,
  fetchCampaignByIdApi,
  fetchBrandsSummaryApi,
  createBrandApi,
  linkOutletsToBrandsApi,
  fetchDistributionPlansApi,
  fetchDistributionTemplatesApi,
} from '../../api';

import {
  CLEAR_RESTAURANT_DETAILS,
  CLEAR_RESTAURANT_POS_INTEGRATIONS,
  CREATE_SUGGEST_CAMPAIGN,
  UPDATE_SUGGEST_CAMPAIGN,
  FETCH_GUEST_SEGMENTS_DATA,
  FETCH_RESTAURANT_DETAILS_BY_SCAN_CODE,
  FETCH_RESTAURANT_POS_INTEGRATIONS,
  FETCH_SUGGESTED_CAMPAIGNS,
  FETCH_ALL_BRANDS,
  CLEAR_ALL_BRANDS,
  FETCH_SUGGESTED_CAMPAIGN_BRANDS,
  CLEAR_SUGGESTED_CAMPAIGN_BRANDS,
  // SUGGEST_CAMPAIGN_TO_BRANDS,
  FETCH_CAMPAIGN_BY_ID,
  CLEAR_SUGGEST_CAMPAIGN,
  FETCH_BRANDS_SUMMARY,
  FETCH_DISTRIBUTION_PLANS,
  FETCH_DISTRIBUTION_TEMPLATES,
} from './actionTypes';

// common actions import
import { beginAjaxCallAction, endAjaxCallAction, apiErrorResponseAction } from '../common';

export const createRestaurantDashboardAction = (formData, accessToken) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const createRestaurantResponse = await createRestaurantDashboardApi({ formData, accessToken })
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return createRestaurantResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const fetchRestaurantDetailsByRestaurantCodeAction =
  (restaurantCode) => async (dispatch) => {
    try {
      const fetchRestaurantDetailsByScanCodeAPIResponse = await fetchRestaurantDetailsByScanCodeAPI(
        {
          scanCode: restaurantCode,
        },
      )
        .then((response) => {
          dispatch({
            type: FETCH_RESTAURANT_DETAILS_BY_SCAN_CODE,
            restaurant: response?.data?.restaurant ?? {},
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return fetchRestaurantDetailsByScanCodeAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

export const clearRestaurantDetailsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESTAURANT_DETAILS,
  });
};

export const fetchRestaurantPosIntegrationAction =
  ({ restaurantCode, integrationType }) =>
  async (dispatch) => {
    try {
      const restaurantPosIntegrationsResponse = await getRestaurantIntegrationsApi({
        restaurantCode,
      })
        .then((responseBody) => {
          const posIntegrationProperties = responseBody?.data?.find(
            (integration) => integration?.integrationType === integrationType,
          );

          dispatch({
            type: FETCH_RESTAURANT_POS_INTEGRATIONS,
            posIntegrationProperties,
          });

          return responseBody;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return restaurantPosIntegrationsResponse;
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

export const clearRestaurantPosIntegrationAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESTAURANT_POS_INTEGRATIONS,
  });
};

export const updatePOSSyncStatusAction =
  ({ restaurantCode, mappingId, syncStatus, restaurantId, accessToken }) =>
  async (dispatch) => {
    try {
      const updatePOSSyncStatusAPIResponse = await updatePOSSyncStatusAPI({
        restaurantCode,
        mappingId,
        syncStatus,
        restaurantId,
        accessToken,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return updatePOSSyncStatusAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

export const fetchGuestSegmentsDataAction = () => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const guestSegmentsResponse = await fetchGuestSegmentsDataApi()
      .then((response) => {
        dispatch({
          type: FETCH_GUEST_SEGMENTS_DATA,
          guestSegments: response?.data?.data ?? [],
        });
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return guestSegmentsResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const createSuggestCampaignAction =
  ({ suggestCampaignReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const suggestCampaignResponse = await createSuggestCampaignApi({ suggestCampaignReqBody })
        .then((response) => {
          dispatch({
            type: CREATE_SUGGEST_CAMPAIGN,
            suggestCampaign: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return suggestCampaignResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchSuggestedCampaignsAction =
  ({ params }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const guestSegmentsResponse = await fetchSuggestedCampaignsApi({ params })
        .then((response) => {
          dispatch({
            type: FETCH_SUGGESTED_CAMPAIGNS,
            suggestedCampaigns: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return guestSegmentsResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateSuggestCampaignAction =
  ({ suggestCampaignReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const suggestCampaignResponse = await updateSuggestCampaignApi({ suggestCampaignReqBody })
        .then((response) => {
          dispatch({
            type: UPDATE_SUGGEST_CAMPAIGN,
            suggestCampaign: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return suggestCampaignResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchAllBrandsAction =
  ({ page, size, requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const allBrandsApiResponse = await fetchAllBrandsApi({ page, size, requestBody })
        .then((response) => {
          dispatch({
            type: FETCH_ALL_BRANDS,
            allBrands: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return allBrandsApiResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearAllBrandsDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ALL_BRANDS,
  });
};

export const fetchSuggestedCampaignBrandsAction =
  ({ page, size, templateIds }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const suggestedCampaignBrandsApiResponse = await fetchSuggestedCampaignBrandsApi({
        page,
        size,
        templateIds,
      })
        .then((response) => {
          dispatch({
            type: FETCH_SUGGESTED_CAMPAIGN_BRANDS,
            suggestedCampaignBrands: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return suggestedCampaignBrandsApiResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearSuggestedCampaignBrandsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SUGGESTED_CAMPAIGN_BRANDS,
  });
};

export const suggestCampaignToBrandsAction =
  ({ requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const suggestCampaignToBrandsApiResponse = await suggestCampaignToBrandsApi({ requestBody })
        .then((response) => {
          // dispatch({
          //   type: SUGGEST_CAMPAIGN_TO_BRANDS,
          //   suggestedCampaignBrands: response?.data ?? {},
          // });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return suggestCampaignToBrandsApiResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchCampaignByIdAction =
  ({ campaignId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const campaignByIdResponse = await fetchCampaignByIdApi({ campaignId })
        .then((response) => {
          dispatch({
            type: FETCH_CAMPAIGN_BY_ID,
            suggestCampaign: response?.data ?? {},
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return campaignByIdResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearSuggestCampaignDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SUGGEST_CAMPAIGN,
  });
};

export const fetchBrandsSummaryAction = (requestBody, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const brandsSummaryResponse = await fetchBrandsSummaryApi(requestBody, url)
      .then((response) => {
        dispatch({
          type: FETCH_BRANDS_SUMMARY,
          brands: response?.data ?? {},
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return brandsSummaryResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const createBrandAction =
  ({ accessToken, requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const createBrandResponse = await createBrandApi({ accessToken, requestBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return createBrandResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const linkOutletsToBrandsAction =
  ({ accessToken, requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const linkOutletsToBrandsResponse = await linkOutletsToBrandsApi({ accessToken, requestBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return linkOutletsToBrandsResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchDistributionPlansAction = () => async (dispatch) => {
  try {
    const distributionPlansAPIResponse = await fetchDistributionPlansApi()
      .then((response) => {
        dispatch({
          type: FETCH_DISTRIBUTION_PLANS,
          distributionPlans: response?.data?.distributionPlans ?? [],
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(errorResponse?.response?.data ?? {}));
        return errorResponse?.response ?? {};
      });
    return distributionPlansAPIResponse;
  } catch (err) {
    console.error(err);
  }
};

export const fetchDistributionTemplatesAction = () => async (dispatch) => {
  try {
    const distributionTemplatesAPIResponse = await fetchDistributionTemplatesApi()
      .then((response) => {
        dispatch({
          type: FETCH_DISTRIBUTION_TEMPLATES,
          distributionTemplates: response?.data ?? [],
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(errorResponse?.response?.data ?? {}));
        return errorResponse?.response ?? {};
      });
    return distributionTemplatesAPIResponse;
  } catch (err) {
    console.error(err);
  }
};
